// Correlação para erros exibidos: o id do servidor quando existe; senão um id de cliente para o suporte cruzar logs.
import { GiyusApiError, GiyusNetworkError } from '@giyus/api-client';

export function correlationIdOf(error: unknown, fallback: () => string): string {
  if (error instanceof GiyusApiError || error instanceof GiyusNetworkError) {
    return error.correlationId ?? fallback();
  }
  return fallback();
}

export function defaultClientCorrelationId(): string {
  return `web-${crypto.randomUUID()}`;
}
